module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/checkmark-a60ed0a0d768c901d1d6f42c3be76ada.svg";